import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, unref as _unref } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = { key: 3 }

import { ref } from "vue";
import GameGrid from "./GameGrid.vue";
import GameCommand from "./GameCommand.vue";
import GameRoverDeploy from "./GameRoverDeploy.vue";
import { generateObstacles } from "@/utils/GenerateObstacles";
import { Direction } from "@/models/Directon";
import { Rover } from "@/models/Rover";
import { Obstacle } from "@/models/Obstacle";
import { Position } from "@/models/Position";

export default /*@__PURE__*/_defineComponent({
  __name: 'GameManager',
  setup(__props) {

const gridSize = ref(200);
const roverInstance = ref<Rover | null>(null);
const obstacles = ref<Obstacle[]>([]);
const positionObstacle = new Set<string>();

const moveRover = (command: "forward" | "turnLeft" | "turnRight") => {
  if (!roverInstance.value || !roverInstance.value.getAlive()) {
    return;
  }

  switch (command) {
    case "forward":
      if (!validateRover()) {
        roverInstance.value.setAlive(false);
        return;
      }

      roverInstance.value.moveForward();
      break;

    case "turnLeft":
      roverInstance.value.turnLeft();
      break;

    case "turnRight":
      roverInstance.value.turnRight();
      break;
  }
};

const validateRover = (): boolean => {
  const position = roverInstance.value!.preForward();

  return !(positionIsObstacle(position) || positionIsOutsideOfset(position));
};

const positionIsObstacle = (position: Position) => {
  return positionObstacle.has(position.x + "," + position.y);
};

const positionIsOutsideOfset = (position: Position) => {
  return (
    position.x < 0 ||
    position.y < 0 ||
    gridSize.value <= position.x ||
    gridSize.value <= position.y
  );
};

const deployRover = (rover: Rover) => {
  roverInstance.value = rover;
  obstacles.value = generateObstacles(gridSize.value, 300);
  positionObstacle.clear();
  obstacles.value.forEach((obstacle) => {
    positionObstacle.add(
      obstacle.getPosition().x + "," + obstacle.getPosition().y
    );
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!roverInstance.value)
      ? (_openBlock(), _createBlock(GameRoverDeploy, {
          key: 0,
          onDeployRover: deployRover
        }))
      : _createCommentVNode("", true),
    (roverInstance.value)
      ? (_openBlock(), _createBlock(GameCommand, {
          key: 1,
          onMove: moveRover
        }))
      : _createCommentVNode("", true),
    (roverInstance.value?.getAlive() === false)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, " Obstacle encountered at (X:" + _toDisplayString(roverInstance.value.preForward().x) + ", Y:" + _toDisplayString(roverInstance.value.preForward().y) + ") ", 1))
      : (roverInstance.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, " Rover Position: (X:" + _toDisplayString(roverInstance.value.getPosition().x) + ", Y:" + _toDisplayString(roverInstance.value.getPosition().y) + ", D:" + _toDisplayString(_unref(Direction)[roverInstance.value.getDirection()]) + ") ", 1))
        : _createCommentVNode("", true),
    (roverInstance.value !== null)
      ? (_openBlock(), _createBlock(GameGrid, {
          key: 4,
          gridSize: gridSize.value,
          obstacles: obstacles.value,
          rover: roverInstance.value
        }, null, 8, ["gridSize", "obstacles", "rover"]))
      : _createCommentVNode("", true)
  ]))
}
}

})